/* eslint-disable max-len */
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const ArrowLeftButton = ({ className }) => (
  <SvgIcon viewBox='0 0 28 28' className={className}>
    <rect id='Прямоугольник_72027' data-name='Прямоугольник 72027' width='28' height='28' rx='7' fill='rgba(0,133,255,0.1)' />
    <path id='Контур_13756' data-name='Контур 13756' d='M2360.908,1120.023l4.5,4.5,4.5-4.5' transform='translate(-1108.023 2379.908) rotate(-90)' fill='none' stroke='#0085ff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
  </SvgIcon>
);

export default ArrowLeftButton;
